import { CorpType } from '../constant.mjs';
import FUC_CODE from '../fucCode.mjs';
import KOREAN_NAME from '../koreanName.mjs';
import MY_DATA_ORG_CODE from '../myDataOrgCode.mjs';

const FINANCIAL_NAME_MAP = new Map(Object.entries({
  영진상호저축은행: '영진저축',
  영진저축은행: '영진저축',
  국민은행: 'KB국민은행',
  국민카드: 'KB국민카드',
  대아상호저축은행: '대아저축',
  대아저축은행: '대아저축',
  디에이치저축은행: '디에이치저축',
  DH저축은행: '디에이치저축',
  삼성생명금융서비스보험대리점: '삼성생명',
  삼성생명보험: '삼성생명',
  신한저축은행: '신한저축',
  인성저축은행: '인성저축',
  인성상호저축은행: '인성저축',
  케이비손해보험: 'KB손해',
  KB손해보험: 'KB손해',
  케이비저축은행: 'KB저축',
  KB저축은행: 'KB저축',
  코리아에셋머니대부: '코리아에셋투자증권',
  평택저축은행: '평택저축',
  평택상호저축은행: '평택저축',
  한성저축은행청주지점: '한성저축',
  한성상호저축은행: '한성저축',
  한성저축은행: '한성저축',
  고려상호저축은행: '고려저축',
  주식회사고려저축은행: '고려저축',
  부산고려저축은행: '고려저축',
  광주지방국세청: '국세청',
  대구지방국세청: '국세청',
  대전지방국세청: '국세청',
  부산지방국세청: '국세청',
  서울지방국세청: '국세청',
  중부지방국세청: '국세청',
  교보생명보험: '교보생명',
  국제상호저축은행: '국제저축',
  국제저축은행: '국제저축',
  금화상호저축은행: '금화저축',
  금화저축은행: '금화저축',
  기업은행: 'IBK기업은행',
  기업은행카드: 'IBK기업카드',
  중소기업은행: 'IBK기업은행',
  남양상호저축은행: '남양저축',
  남양저축은행: '남양저축',
  농협생명보험: 'NH농협생명',
  농협손해보험: 'NH농협손해',
  농협은행: 'NH농협은행',
  농협카드: 'NH농협카드',
  다올저축은행: '다올저축',
  대명상호저축은행: '대명저축',
  대명저축은행: '대명저축',
  대백저축은행: '대백저축',
  대신저축은행: '대신저축',
  대원상호저축은행: '대원저축',
  대원저축은행: '대원저축',
  대한상호저축은행: '대한저축',
  대한저축은행: '대한저축',
  더블저축은행: '더블저축',
  더케이저축은행: '더케이저축',
  데라게란덴파이낸스: '데라게란덴',
  동양상호저축은행: '동양저축',
  동양저축은행: '동양저축',
  동양생명보험: '동양생명',
  동원제일저축은행: '동원제일저축',
  동원제일저축은행중금리: '동원제일저축',
  드림상호저축은행: '드림저축',
  드림저축은행: '드림저축',
  디비금융투자: 'DB금융투자',
  디비저축은행: '디비저축',
  디비캐피탈주식회사: 'DB캐피탈',
  디에스투자증권: 'DS투자증권',
  iM뱅크: 'iM뱅크',
  아이엠뱅크: 'iM뱅크',
  '(주)아이엠뱅크': 'iM뱅크',
  아이엠캐피탈: 'iM캐피탈',
  iM캐피탈: 'iM캐피탈',
  주식회사아이엠캐피탈: 'iM캐피탈',
  디지비캐피탈: 'iM캐피탈',
  iMT라이프생명보험: 'iMT라이프생명',
  iM증권: 'iM증권',
  iM에셋자산운용: 'iM증권',
  롯데손해보험: '롯데손해',
  롯데손해보험주식회사: '롯데손해',
  롯데카드주식회사: '롯데카드',
  리딩투자증권주식회사: '리딩투자증권',
  머스트삼일저축은행: '머스트삼일',
  메르세데스벤츠파이낸셜서비스: '벤츠파이낸셜',
  메르세데스벤츠파이낸셜서비스코리아: '벤츠파이낸셜',
  메리츠화재해상보험: '메리츠화재',
  메리츠화재해상보험주식회사: '메리츠화재',
  메트라이프생명보험: '메트라이프생명',
  모아상호저축은행: '모아저축',
  모아저축은행: '모아저축',
  무림캐피탈주식회사: '무림캐피탈',
  미래에셋생명보험: '미래에셋생명',
  민국상호저축은행: '민국저축',
  민국저축은행: '민국저축',
  별정우체국연금관리단: '우체국',
  우정사업본부: '우체국',
  우정사업정보센터: '우체국',
  볼보파이낸셜서비스코리아: '볼보파이낸셜',
  부림상호저축은행: '부림저축',
  부림저축은행: '부림저축',
  비엔케이저축은행: 'BNK저축',
  BNK저축은행: 'BNK저축',
  비엔케이캐피탈: 'BNK캐피탈',
  비엔피파리바카디프생명보험: 'BNP파리바생명',
  산업은행: 'KDB산업은행',
  한국산업은행: 'KDB산업은행',
  산은캐피탈: 'KDB캐피탈',
  삼성카드주식회사: '삼성카드',
  삼성화재해상보험: '삼성화재',
  삼정상호저축은행: '삼정저축',
  삼정저축은행: '삼정저축',
  삼호저축은행: '삼호저축',
  상상인저축은행: '상상인저축',
  세람상호저축은행: '세람저축',
  세람저축은행: '세람저축',
  센트럴저축은행: '센트럴저축',
  솔브레인저축은행: '솔브레인저축',
  수출입은행: '한국수출입은행',
  스마트상호저축은행: '스마트저축',
  스마트저축은행: '스마트저축',
  스카니아파이낸스코리아서울: '스카니아파이낸스코리아',
  스카이상호저축은행: '스카이저축',
  스카이저축은행: '스카이저축',
  스타상호저축은행: '스타저축',
  스타저축은행: '스타저축',
  신한라이프신한생명: '신한라이프',
  신한라이프생명보험: '신한라이프',
  신한카드주식회사: '신한카드',
  신협중앙회본부: '신협',
  신용협동조합중앙회: '신협',
  씨케이저축은행: 'CK저축',
  강원저축은행: 'CK저축',
  아산상호저축은행: '아산저축',
  아산저축은행: '아산저축',
  아이비케이저축은행: 'IBK저축',
  IBK저축은행: 'IBK저축',
  아이비케이투자증권: 'IBK투자증권',
  악사손해보험: 'AXA손해',
  안국상호저축은행: '안국저축',
  안국저축은행: '안국저축',
  안양상호저축은행: '안양저축',
  안양저축은행: '안양저축',
  알씨아이파이낸셜서비스코리아: 'RCI파이낸셜',
  RCI파이낸셜서비스: 'RCI파이낸셜',
  애큐온저축은행: '애큐온저축',
  에스비아이저축은행: 'SBI저축',
  SBI저축은행: 'SBI저축',
  SBI2저축은행: 'SBI저축',
  SBI3저축은행: 'SBI저축',
  SBI4저축은행: 'SBI저축',
  에스앤티상호저축은행: '에스앤티저축',
  에이비엘생명: 'ABL생명',
  에이비엘생명보험: 'ABL생명',
  엔에이치농협캐피탈주식회사: 'NH농협캐피탈',
  엔에이치저축은행: 'NH저축',
  NH저축은행: 'NH저축',
  엠에스상호저축은행: '엠에스저축',
  엠에스저축은행: '엠에스저축',
  예가람상호저축은행: '예가람저축',
  예가람저축은행: '예가람저축',
  오릭스캐피탈코리아: '오릭스캐피탈',
  오릭스캐피탈코리아주식회사: '오릭스캐피탈',
  오성저축은행: '오성저축',
  오에스비저축은행: 'OSB저축',
  OSB저축은행: 'OSB저축',
  오케이캐피탈우리대부: 'OK캐피탈',
  오케이캐피탈: 'OK캐피탈',
  오케이캐피탈전당포대부: 'OK캐피탈',
  OK캐피탈2: 'OK캐피탈',
  오케이저축은행: 'OK저축',
  OK저축은행: 'OK저축',
  OK저축은행2: 'OK저축',
  오투저축은행: '오투저축',
  외환은행: '하나은행',
  KEB하나은행: '하나은행',
  하나은행SOHO: '하나은행',
  우리금융저축은행: '우리금융저축',
  우리상호저축은행: '우리저축',
  우리저축은행: '우리저축',
  우리투자증권: 'NH투자증권',
  웰컴저축은행: '웰컴저축',
  웰컴저축은행주식회사: '웰컴저축',
  유니온상호저축은행: '유니온저축',
  주식회사유니온상호저축은행: '유니온저축',
  유니온저축은행: '유니온저축',
  유안타저축은행: '유안타저축',
  융창상호저축은행: '융창저축',
  융창저축은행: '융창저축',
  이베스트투자증권: '이베스트증권',
  인천상호저축은행: '인천저축',
  인천저축은행: '인천저축',
  제이비우리캐피탈: 'JB우리캐피탈',
  제이티저축은행: 'JT저축',
  제이티친애저축은행: 'JT친애저축',
  제이피인베스트먼트대부: 'JP모간',
  조은저축은행: '조은저축',
  주식회사케이뱅크: '케이뱅크',
  주식회사한국씨티은행: '씨티은행',
  한국씨티은행: '씨티은행',
  주식회사우리카드: '우리카드',
  중국공상은행: '중국공상',
  중국은행서울지점: '중국은행',
  진주상호저축은행: '진주저축',
  진주저축은행: '진주저축',
  참저축은행: '참저축',
  처브라이프생명보험: '처브라이프생명',
  청주상호저축은행: '청주저축',
  청주저축은행: '청주저축',
  케이디비생명보험: 'KDB생명',
  키움예스저축은행: '키움예스',
  키움저축은행: '키움저축',
  토요타파이낸셜서비스: '토요타파이낸셜',
  토요타파이낸셜서비스코리아: '토요타파이낸셜',
  페퍼저축은행: '페퍼저축',
  페퍼저축은행2: '페퍼저축',
  폭스바겐파이낸셜서비스코리아: '폭스바겐파이낸셜',
  푸른상호저축은행: '푸른저축',
  푸른저축은행: '푸른저축',
  푸본현대생명보험: '푸본현대생명',
  하나저축은행: '하나저축',
  하이투자증권주식회사: 'iM증권',
  한국스탠다드차타드: 'SC제일은행',
  한국스탠다드차타드은행: 'SC제일은행',
  한국스탠다드차타드은행카드: 'SC제일카드',
  한국자산캐피탈주식회사: '한국자산캐피탈',
  한국투자저축은행: '한국투자저축',
  한국투자캐피탈주식회사: '한국투자캐피탈',
  한국포스증권주식회사: '한국포스증권',
  한화생명보험: '한화생명',
  한화손해보험: '한화손해',
  한화저축은행: '한화저축',
  주식회사현대백화점: '현대백화점카드',
  현대차증권주식회사: '현대차증권',
  현대캐피탈주식회사: '현대캐피탈',
  현대커머셜주식회사: '현대커머셜',
  현대해상화재: '현대해상',
  현대해상화재보험: '현대해상',
  흥국상호저축은행: '흥국저축',
  흥국저축은행: '흥국저축',
  흥국생명보험: '흥국생명',
  흥국화재해상보험: '흥국화재',
  BC카드: '비씨카드',
  BMW파이낸셜서비스코리아: 'BMW파이낸셜',
  BMW파이낸셜서비스: 'BMW파이낸셜',
  DB손해보험: 'DB손해',
  DB생명보험: 'DB생명',
  KB라이프생명푸르: 'KB라이프생명',
  굿모닝신한증권: '신한투자증권',
  신한금융투자: '신한투자증권',
  미국신한은행: '신한은행',
  베트남신한은행: '신한은행',
  신한은행인도네시아: '신한은행',
  신한은행중국유한공사: '신한은행',
  인도네시아신한은행: '신한은행',
  일본신한은행: '신한은행',
  캄보디아신한은행: '신한은행',
  캐나다신한은행: '신한은행',
  필리핀신한은행: '신한은행',
  신안저축은행: '신안저축',
  알리안츠생명보험: '알리안츠제일생명보험',
  제일화재해상보험: '제일화재',
  조흥저축은행: '조흥저축',
  하이델베르그프린트파이낸스코리아: '하이델베르그',
  AIG손해보험: 'AIG손해',
  HSBC은행: 'HSBC',
  MG손해보험: 'MG손해',
  HB저축은행: 'HB저축',
  네이버페이: '네이버페이',
  카카오페이: '카카오페이'
}));
const FINANCIAL_CODE_DICTIONARY = {
  ORG_KFTC: {
    type: null,
    name: '사단법인 금융결제원',
    myDataOrgCode: MY_DATA_ORG_CODE.ORG_KFTC,
    fucCode: null
  },
  ORG_KOSCOM: {
    type: null,
    name: '(주)코스콤',
    myDataOrgCode: MY_DATA_ORG_CODE.ORG_KOSCOM,
    fucCode: null
  },
  ORG_SIGNGATE: {
    type: null,
    name: '한국정보인증주식회사',
    myDataOrgCode: MY_DATA_ORG_CODE.ORG_SIGNGATE,
    fucCode: null
  },
  BK_KB: {
    type: CorpType.BANK,
    name: 'KB국민은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_KB,
    fucCode: FUC_CODE.BK_KB
  },
  BK_SHINHAN: {
    type: CorpType.BANK,
    name: '신한은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_SHINHAN,
    fucCode: FUC_CODE.BK_SHINHAN
  },
  BK_HANA: {
    type: CorpType.BANK,
    name: '하나은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_HANA,
    fucCode: FUC_CODE.BK_HANA
  },
  BK_WOORI: {
    type: CorpType.BANK,
    name: '우리은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_WOORI,
    fucCode: FUC_CODE.BK_WOORI
  },
  BK_KAKAO: {
    type: CorpType.BANK,
    name: '카카오뱅크',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_KAKAO,
    fucCode: FUC_CODE.BK_KAKAO
  },
  BK_K: {
    type: CorpType.BANK,
    name: '케이뱅크',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_K,
    fucCode: FUC_CODE.BK_K
  },
  BK_IBK: {
    type: CorpType.BANK,
    name: 'IBK기업은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_IBK,
    fucCode: FUC_CODE.BK_IBK
  },
  BK_NH: {
    type: CorpType.BANK,
    name: 'NH농협은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_NH,
    fucCode: FUC_CODE.BK_NH
  },
  BK_KDB: {
    type: CorpType.BANK,
    name: 'KDB산업은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_KDB,
    fucCode: FUC_CODE.BK_KDB
  },
  BK_SC: {
    type: CorpType.BANK,
    name: 'SC제일은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_SC,
    fucCode: FUC_CODE.BK_SC
  },
  BK_BUSAN: {
    type: CorpType.BANK,
    name: '부산은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_BUSAN,
    fucCode: FUC_CODE.BK_BUSAN
  },
  BK_DAEGU: {
    type: CorpType.BANK,
    name: 'iM뱅크',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_DAEGU,
    fucCode: FUC_CODE.BK_DAEGU
  },
  BK_KYOUNGNAM: {
    type: CorpType.BANK,
    name: '경남은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_KYOUNGNAM,
    fucCode: FUC_CODE.BK_KYOUNGNAM
  },
  BK_SH: {
    type: CorpType.BANK,
    name: '수협은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_SH,
    fucCode: FUC_CODE.BK_SH
  },
  BK_KWANGJU: {
    type: CorpType.BANK,
    name: '광주은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_KWANGJU,
    fucCode: FUC_CODE.BK_KWANGJU
  },
  BK_JEONBUK: {
    type: CorpType.BANK,
    name: '전북은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_JEONBUK,
    fucCode: FUC_CODE.BK_JEONBUK
  },
  BK_JEJU: {
    type: CorpType.BANK,
    name: '제주은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_JEJU,
    fucCode: FUC_CODE.BK_JEJU
  },
  BK_EPOST: {
    type: CorpType.BANK,
    name: '우체국은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_EPOST,
    fucCode: FUC_CODE.BK_EPOST
  },
  BK_TOSS: {
    type: CorpType.BANK,
    name: '토스뱅크',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_TOSS,
    fucCode: FUC_CODE.BK_TOSS
  },
  BK_HF: {
    type: CorpType.BANK,
    name: '한국주택금융공사',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_HF,
    fucCode: null
  },
  BK_KOSAF: {
    type: CorpType.BANK,
    name: '한국장학재단',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_KOSAF,
    fucCode: null
  },
  BK_KINFA: {
    type: CorpType.BANK,
    name: '서민금융진흥원',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_KINFA,
    fucCode: null
  },
  BK_KFCC: {
    type: CorpType.BANK,
    name: '새마을금고',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_KFCC,
    fucCode: FUC_CODE.BK_KFCC
  },
  BK_CU: {
    type: CorpType.BANK,
    name: '신협',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_CU,
    fucCode: FUC_CODE.BK_CU
  },
  BK_SHCENTRAL: {
    type: CorpType.BANK,
    name: '수협중앙회',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_SHCENTRAL,
    fucCode: FUC_CODE.BK_SHCENTRAL
  },
  BK_NHCENTRAL: {
    type: CorpType.BANK,
    name: '농협중앙회',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_NHCENTRAL,
    fucCode: FUC_CODE.BK_NHCENTRAL
  },
  BK_CITI: {
    type: CorpType.BANK,
    name: '씨티은행',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_CITI,
    fucCode: FUC_CODE.BK_CITI
  },
  BK_DEUTSCH: {
    type: CorpType.BANK,
    name: '도이치은행',
    myDataOrgCode: null,
    fucCode: FUC_CODE.BK_DEUTSCH
  },
  BK_BOA: {
    type: CorpType.BANK,
    name: 'BOA',
    myDataOrgCode: null,
    fucCode: FUC_CODE.BK_BOA
  },
  BK_BNP: {
    type: CorpType.BANK,
    name: 'BNP파리바',
    myDataOrgCode: null,
    fucCode: FUC_CODE.BK_BNP
  },
  BK_JPMORGAN: {
    type: CorpType.BANK,
    name: 'JP모간',
    myDataOrgCode: null,
    fucCode: FUC_CODE.BK_JPMORGAN
  },
  BK_ICBC: {
    type: CorpType.BANK,
    name: '중국공상은행',
    myDataOrgCode: null,
    fucCode: FUC_CODE.BK_ICBC
  },
  BK_CHINA: {
    type: CorpType.BANK,
    name: '중국은행',
    myDataOrgCode: null,
    fucCode: FUC_CODE.BK_CHINA
  },
  BK_CCB: {
    type: CorpType.BANK,
    name: '중국건설',
    myDataOrgCode: null,
    fucCode: FUC_CODE.BK_CCB
  },
  BK_K_NPAY: {
    type: CorpType.BANK,
    name: KOREAN_NAME.BK_K_NPAY,
    myDataOrgCode: null,
    fucCode: null
  },
  BK_SHINHAN_NPAY: {
    type: CorpType.BANK,
    name: KOREAN_NAME.BK_SHINHAN_NPAY,
    myDataOrgCode: null,
    fucCode: null
  },
  IV_MIRAE: {
    type: CorpType.INVEST,
    name: '미래에셋증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_MIRAE,
    fucCode: FUC_CODE.IV_MIRAE
  },
  IV_KIWOOM: {
    type: CorpType.INVEST,
    name: '키움증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_KIWOOM,
    fucCode: FUC_CODE.IV_KIWOOM
  },
  IV_KB: {
    type: CorpType.INVEST,
    name: 'KB증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_KB,
    fucCode: FUC_CODE.IV_KB
  },
  IV_SAMSUNG: {
    type: CorpType.INVEST,
    name: '삼성증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_SAMSUNG,
    fucCode: FUC_CODE.IV_SAMSUNG
  },
  IV_KOREA: {
    type: CorpType.INVEST,
    name: '한국투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_KOREA,
    fucCode: FUC_CODE.IV_KOREA
  },
  IV_SHINHAN: {
    type: CorpType.INVEST,
    name: '신한투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_SHINHAN,
    fucCode: FUC_CODE.IV_SHINHAN
  },
  IV_NH: {
    type: CorpType.INVEST,
    name: 'NH투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_NH,
    fucCode: FUC_CODE.IV_NH
  },
  IV_HANA: {
    type: CorpType.INVEST,
    name: '하나금융투자',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_HANA,
    fucCode: FUC_CODE.IV_HANA
  },
  IV_DAISHIN: {
    type: CorpType.INVEST,
    name: '대신증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_DAISHIN,
    fucCode: FUC_CODE.IV_DAISHIN
  },
  IV_KAKAOPAY: {
    type: CorpType.INVEST,
    name: '카카오페이증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_KAKAOPAY,
    fucCode: FUC_CODE.IV_KAKAOPAY
  },
  IV_TOSS: {
    type: CorpType.INVEST,
    name: '토스증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_TOSS,
    fucCode: FUC_CODE.IV_TOSS
  },
  IV_MERITZ: {
    type: CorpType.INVEST,
    name: '메리츠증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_MERITZ,
    fucCode: FUC_CODE.IV_MERITZ
  },
  IV_YUANTA: {
    type: CorpType.INVEST,
    name: '유안타증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_YUANTA,
    fucCode: FUC_CODE.IV_YUANTA
  },
  IV_KYOBO: {
    type: CorpType.INVEST,
    name: '교보증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_KYOBO,
    fucCode: FUC_CODE.IV_KYOBO
  },
  IV_EUGENE: {
    type: CorpType.INVEST,
    name: '유진투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_EUGENE,
    fucCode: FUC_CODE.IV_EUGENE
  },
  IV_HM: {
    type: CorpType.INVEST,
    name: '현대차증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_HM,
    fucCode: FUC_CODE.IV_HM
  },
  IV_DBFI: {
    type: CorpType.INVEST,
    name: 'DB금융투자',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_DBFI,
    fucCode: FUC_CODE.IV_DBFI
  },
  IV_HI: {
    type: CorpType.INVEST,
    name: 'iM증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_HI,
    fucCode: FUC_CODE.IV_HI
  },
  IV_LS: {
    type: CorpType.INVEST,
    name: 'LS증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_LS,
    fucCode: FUC_CODE.IV_LS
  },
  IV_HANWHA: {
    type: CorpType.INVEST,
    name: '한화투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_HANWHA,
    fucCode: FUC_CODE.IV_HANWHA
  },
  IV_SK: {
    type: CorpType.INVEST,
    name: 'SK증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_SK,
    fucCode: FUC_CODE.IV_SK
  },
  IV_KTB: {
    type: CorpType.INVEST,
    name: 'KTB투자증권',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IV_KTB
  },
  IV_DAOL: {
    type: CorpType.INVEST,
    name: '다올투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_DAOL,
    fucCode: FUC_CODE.IV_DAOL
  },
  IV_SHINYOUNG: {
    type: CorpType.INVEST,
    name: '신영증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_SHINYOUNG,
    fucCode: FUC_CODE.IV_SHINYOUNG
  },
  IV_FOSS: {
    type: CorpType.INVEST,
    name: '우리투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_FOSS,
    fucCode: FUC_CODE.IV_FOSS
  },
  IV_IBK: {
    type: CorpType.INVEST,
    name: 'IBK투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_IBK,
    fucCode: FUC_CODE.IV_IBK
  },
  IV_WOORI: {
    type: CorpType.INVEST,
    name: '우리종합금융',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_WOORI,
    fucCode: FUC_CODE.IV_WOORI
  },
  IV_HANKUK: {
    type: CorpType.INVEST,
    name: '한국증권금융',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_HANKUK,
    fucCode: FUC_CODE.IV_HANKUK
  },
  IV_NAVER_MIRAE: {
    type: CorpType.INVEST,
    name: KOREAN_NAME.IV_NAVER_MIRAE,
    myDataOrgCode: null,
    fucCode: null
  },
  CD_SHINHAN: {
    type: CorpType.CARD,
    name: '신한카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_SHINHAN,
    fucCode: FUC_CODE.CD_SHINHAN
  },
  CD_SAMSUNG: {
    type: CorpType.CARD,
    name: '삼성카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_SAMSUNG,
    fucCode: FUC_CODE.CD_SAMSUNG
  },
  CD_KB: {
    type: CorpType.CARD,
    name: 'KB국민카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_KB,
    fucCode: FUC_CODE.CD_KB
  },
  CD_HYUNDAI: {
    type: CorpType.CARD,
    name: '현대카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_HYUNDAI,
    fucCode: FUC_CODE.CD_HYUNDAI
  },
  CD_BC: {
    type: CorpType.CARD,
    name: '비씨카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_BC,
    fucCode: FUC_CODE.CD_BC
  },
  CD_HANA: {
    type: CorpType.CARD,
    name: '하나카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_HANA,
    fucCode: FUC_CODE.CD_HANA
  },
  CD_WOORI: {
    type: CorpType.CARD,
    name: '우리카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_WOORI,
    fucCode: FUC_CODE.CD_WOORI
  },
  CD_LOTTE: {
    type: CorpType.CARD,
    name: '롯데카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_LOTTE,
    fucCode: FUC_CODE.CD_LOTTE
  },
  CD_NH: {
    type: CorpType.CARD,
    name: 'NH농협카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_NH,
    fucCode: FUC_CODE.CD_NH
  },
  CD_IBK: {
    type: CorpType.CARD,
    name: 'IBK기업카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_IBK,
    fucCode: FUC_CODE.CD_IBK
  },
  CD_SC: {
    type: CorpType.CARD,
    name: 'SC제일카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_SC,
    fucCode: null
  },
  CD_KDB: {
    type: CorpType.CARD,
    name: 'KDB산업카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_KDB,
    fucCode: null
  },
  CD_KFCC: {
    type: CorpType.CARD,
    name: '새마을금고카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_KFCC,
    fucCode: null
  },
  CD_EPOST: {
    type: CorpType.CARD,
    name: '우체국카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_EPOST,
    fucCode: null
  },
  CD_CU: {
    type: CorpType.CARD,
    name: '신협카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_CU,
    fucCode: null
  },
  CD_SH: {
    type: CorpType.CARD,
    name: '수협카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_SH,
    fucCode: null
  },
  CD_DAEGU: {
    type: CorpType.CARD,
    name: '대구은행카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_DAEGU,
    fucCode: null
  },
  CD_KWANGJU: {
    type: CorpType.CARD,
    name: '광주은행카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_KWANGJU,
    fucCode: null
  },
  CD_BUSAN: {
    type: CorpType.CARD,
    name: '부산은행카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_BUSAN,
    fucCode: null
  },
  CD_KYOUNGNAM: {
    type: CorpType.CARD,
    name: '경남은행카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_KYOUNGNAM,
    fucCode: null
  },
  CD_JEONBUK: {
    type: CorpType.CARD,
    name: '전북은행카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_JEONBUK,
    fucCode: null
  },
  CD_HYUNDAI_DS: {
    type: CorpType.CARD,
    name: '현대백화점카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_HYUNDAI_DS,
    fucCode: null
  },
  CD_GALLERIA_DS: {
    type: CorpType.CARD,
    name: '갤러리아백화점카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_GALLERIA_DS,
    fucCode: null
  },
  CD_TOSS_BANK: {
    type: CorpType.CARD,
    name: '토스뱅크카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_TOSS_BANK,
    fucCode: null
  },
  CD_K_BANK: {
    type: CorpType.CARD,
    name: '케이뱅크카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_K_BANK,
    fucCode: null
  },
  CD_KAKAO_BANK: {
    type: CorpType.CARD,
    name: '카카오뱅크카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_KAKAO_BANK,
    fucCode: null
  },
  CD_JEJU_BANK: {
    type: CorpType.CARD,
    name: '제주은행카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_JEJU_BANK,
    fucCode: null
  },
  CD_CITI_BANK: {
    type: CorpType.CARD,
    name: '씨티카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_CITI_BANK,
    fucCode: null
  },
  CD_MIRAE_STOCK: {
    type: CorpType.CARD,
    name: '미래에셋증권카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_MIRAE_STOCK,
    fucCode: null
  },
  CD_KB_STOCK: {
    type: CorpType.CARD,
    name: 'KB증권카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_KB_STOCK,
    fucCode: null
  },
  CD_HANKOOK_STOCK: {
    type: CorpType.CARD,
    name: '한국투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_HANKOOK_STOCK,
    fucCode: null
  },
  CD_NH_STOCK: {
    type: CorpType.CARD,
    name: 'NH투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_NH_STOCK,
    fucCode: null
  },
  CD_YUANTA_STOCK: {
    type: CorpType.CARD,
    name: '유안타증권',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_YUANTA_STOCK,
    fucCode: null
  },
  CD_SK_STOCK: {
    type: CorpType.CARD,
    name: 'SK증권',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_SK_STOCK,
    fucCode: null
  },
  CD_HANWHA_STOCK: {
    type: CorpType.CARD,
    name: '한화투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.CD_HANWHA_STOCK,
    fucCode: null
  },
  CD_NAVER_PAY: {
    type: CorpType.CARD,
    name: KOREAN_NAME.CD_NAVER_PAY,
    myDataOrgCode: null,
    fucCode: FUC_CODE.CD_NAVER_PAY
  },
  CD_KAKAO_PAY: {
    type: CorpType.CARD,
    name: KOREAN_NAME.CD_KAKAO_PAY,
    myDataOrgCode: null,
    fucCode: FUC_CODE.CD_KAKAO_PAY
  },
  CD_MASTER_CARD: {
    type: CorpType.CARD,
    name: KOREAN_NAME.CD_MASTER_CARD,
    myDataOrgCode: null,
    fucCode: null
  },
  CD_VISA: {
    type: CorpType.CARD,
    name: KOREAN_NAME.CD_VISA,
    myDataOrgCode: null,
    fucCode: null
  },
  SB_COMMON: {
    type: CorpType.SAVING_BANK,
    name: '저축은행',
    myDataOrgCode: null,
    fucCode: FUC_CODE.SB_COMMON
  },
  SB_SMART: {
    type: CorpType.SAVING_BANK,
    name: '스마트저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SMART,
    fucCode: FUC_CODE.SB_SMART
  },
  SB_TRUE: {
    type: CorpType.SAVING_BANK,
    name: '참저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_TRUE,
    fucCode: FUC_CODE.SB_TRUE
  },
  SB_CENTRAL: {
    type: CorpType.SAVING_BANK,
    name: '센트럴저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_CENTRAL,
    fucCode: FUC_CODE.SB_CENTRAL
  },
  SB_DOUBLE: {
    type: CorpType.SAVING_BANK,
    name: '더블저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DOUBLE,
    fucCode: FUC_CODE.SB_DOUBLE
  },
  SB_DONGYANG: {
    type: CorpType.SAVING_BANK,
    name: '동양저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DONGYANG,
    fucCode: FUC_CODE.SB_DONGYANG
  },
  SB_DAEHAN: {
    type: CorpType.SAVING_BANK,
    name: '대한저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DAEHAN,
    fucCode: FUC_CODE.SB_DAEHAN
  },
  SB_STAR: {
    type: CorpType.SAVING_BANK,
    name: '스타저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_STAR,
    fucCode: FUC_CODE.SB_STAR
  },
  SB_MS: {
    type: CorpType.SAVING_BANK,
    name: '엠에스저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_MS,
    fucCode: FUC_CODE.SB_MS
  },
  SB_DAEBAEK: {
    type: CorpType.SAVING_BANK,
    name: '대백저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DAEBAEK,
    fucCode: FUC_CODE.SB_DAEBAEK
  },
  SB_UNION: {
    type: CorpType.SAVING_BANK,
    name: '유니온저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_UNION,
    fucCode: FUC_CODE.SB_UNION
  },
  SB_DAEAH: {
    type: CorpType.SAVING_BANK,
    name: '대아저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DAEAH,
    fucCode: FUC_CODE.SB_DAEAH
  },
  SB_DAISHIN: {
    type: CorpType.SAVING_BANK,
    name: '대신저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DAISHIN,
    fucCode: FUC_CODE.SB_DAISHIN
  },
  SB_SAMHO: {
    type: CorpType.SAVING_BANK,
    name: '삼호저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SAMHO,
    fucCode: FUC_CODE.SB_SAMHO
  },
  SB_OHTOO: {
    type: CorpType.SAVING_BANK,
    name: '오투저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_OHTOO,
    fucCode: FUC_CODE.SB_OHTOO
  },
  SB_ASAN: {
    type: CorpType.SAVING_BANK,
    name: '아산저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_ASAN,
    fucCode: FUC_CODE.SB_ASAN
  },
  SB_SSINPLUS: {
    type: CorpType.SAVING_BANK,
    name: '상상인플러스',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SSINPLUS,
    fucCode: FUC_CODE.SB_SSINPLUS
  },
  SB_WOORIFIN: {
    type: CorpType.SAVING_BANK,
    name: '우리금융저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_WOORIFIN,
    fucCode: FUC_CODE.SB_WOORIFIN
  },
  SB_CK: {
    type: CorpType.SAVING_BANK,
    name: 'CK저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_CK,
    fucCode: FUC_CODE.SB_CK
  },
  SB_THEK: {
    type: CorpType.SAVING_BANK,
    name: '더케이저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_THEK,
    fucCode: FUC_CODE.SB_THEK
  },
  SB_KIWOOMYES: {
    type: CorpType.SAVING_BANK,
    name: '키움예스',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_KIWOOMYES,
    fucCode: FUC_CODE.SB_KIWOOMYES
  },
  SB_KB: {
    type: CorpType.SAVING_BANK,
    name: 'KB저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_KB,
    fucCode: FUC_CODE.SB_KB
  },
  SB_BARO: {
    type: CorpType.SAVING_BANK,
    name: '바로저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_BARO,
    fucCode: FUC_CODE.SB_BARO
  },
  SB_YUANTA: {
    type: CorpType.SAVING_BANK,
    name: '유안타저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_YUANTA,
    fucCode: FUC_CODE.SB_YUANTA
  },
  SB_OK: {
    type: CorpType.SAVING_BANK,
    name: 'OK저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_OK,
    fucCode: FUC_CODE.SB_OK
  },
  SB_MUSTSAMIL: {
    type: CorpType.SAVING_BANK,
    name: '머스트삼일',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_MUSTSAMIL,
    fucCode: FUC_CODE.SB_MUSTSAMIL
  },
  SB_DONGWONJEIL: {
    type: CorpType.SAVING_BANK,
    name: '동원제일저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DONGWONJEIL,
    fucCode: FUC_CODE.SB_DONGWONJEIL
  },
  SB_OHSUNG: {
    type: CorpType.SAVING_BANK,
    name: '오성저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_OHSUNG,
    fucCode: FUC_CODE.SB_OHSUNG
  },
  SB_BNK: {
    type: CorpType.SAVING_BANK,
    name: 'BNK저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_BNK,
    fucCode: FUC_CODE.SB_BNK
  },
  SB_DAEWON: {
    type: CorpType.SAVING_BANK,
    name: '대원저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DAEWON,
    fucCode: FUC_CODE.SB_DAEWON
  },
  SB_DAEMYUNG: {
    type: CorpType.SAVING_BANK,
    name: '대명저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DAEMYUNG,
    fucCode: FUC_CODE.SB_DAEMYUNG
  },
  SB_HANSUNG: {
    type: CorpType.SAVING_BANK,
    name: '한성저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_HANSUNG,
    fucCode: FUC_CODE.SB_HANSUNG
  },
  SB_CHUNGJU: {
    type: CorpType.SAVING_BANK,
    name: '청주저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_CHUNGJU,
    fucCode: FUC_CODE.SB_CHUNGJU
  },
  SB_KIWOOM: {
    type: CorpType.SAVING_BANK,
    name: '키움저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_KIWOOM,
    fucCode: FUC_CODE.SB_KIWOOM
  },
  SB_DREAM: {
    type: CorpType.SAVING_BANK,
    name: '드림저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DREAM,
    fucCode: FUC_CODE.SB_DREAM
  },
  SB_SOLBRAIN: {
    type: CorpType.SAVING_BANK,
    name: '솔브레인저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SOLBRAIN,
    fucCode: FUC_CODE.SB_SOLBRAIN
  },
  SB_JINJU: {
    type: CorpType.SAVING_BANK,
    name: '진주저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_JINJU,
    fucCode: FUC_CODE.SB_JINJU
  },
  SB_CHOHEUNG: {
    type: CorpType.SAVING_BANK,
    name: '조흥저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_CHOHEUNG,
    fucCode: FUC_CODE.SB_CHOHEUNG
  },
  SB_IBK: {
    type: CorpType.SAVING_BANK,
    name: 'IBK저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_IBK,
    fucCode: FUC_CODE.SB_IBK
  },
  SB_SNT: {
    type: CorpType.SAVING_BANK,
    name: '에스앤티저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SNT,
    fucCode: FUC_CODE.SB_SNT
  },
  SB_DH: {
    type: CorpType.SAVING_BANK,
    name: '디에이치저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DH,
    fucCode: FUC_CODE.SB_DH
  },
  SB_WOORI: {
    type: CorpType.SAVING_BANK,
    name: '우리저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_WOORI,
    fucCode: FUC_CODE.SB_WOORI
  },
  SB_COREA: {
    type: CorpType.SAVING_BANK,
    name: '고려저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_COREA,
    fucCode: FUC_CODE.SB_COREA
  },
  SB_KOOKJE: {
    type: CorpType.SAVING_BANK,
    name: '국제저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_KOOKJE,
    fucCode: FUC_CODE.SB_KOOKJE
  },
  SB_HEUNGKUK: {
    type: CorpType.SAVING_BANK,
    name: '흥국저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_HEUNGKUK,
    fucCode: FUC_CODE.SB_HEUNGKUK
  },
  SB_RAON: {
    type: CorpType.SAVING_BANK,
    name: '라온저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_RAON,
    fucCode: FUC_CODE.SB_RAON
  },
  SB_PURUN: {
    type: CorpType.SAVING_BANK,
    name: '푸른저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_PURUN,
    fucCode: FUC_CODE.SB_PURUN
  },
  SB_ANYANG: {
    type: CorpType.SAVING_BANK,
    name: '안양저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_ANYANG,
    fucCode: FUC_CODE.SB_ANYANG
  },
  SB_PEPPER: {
    type: CorpType.SAVING_BANK,
    name: '페퍼저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_PEPPER,
    fucCode: FUC_CODE.SB_PEPPER
  },
  SB_KUMHWA: {
    type: CorpType.SAVING_BANK,
    name: '금화저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_KUMHWA,
    fucCode: FUC_CODE.SB_KUMHWA
  },
  SB_WELCOME: {
    type: CorpType.SAVING_BANK,
    name: '웰컴저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_WELCOME,
    fucCode: FUC_CODE.SB_WELCOME
  },
  SB_SHINHAN: {
    type: CorpType.SAVING_BANK,
    name: '신한저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SHINHAN,
    fucCode: FUC_CODE.SB_SHINHAN
  },
  SB_JTCHINE: {
    type: CorpType.SAVING_BANK,
    name: 'JT친애저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_JTCHINE,
    fucCode: FUC_CODE.SB_JTCHINE
  },
  SB_NH: {
    type: CorpType.SAVING_BANK,
    name: 'NH저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_NH,
    fucCode: FUC_CODE.SB_NH
  },
  SB_ACUON: {
    type: CorpType.SAVING_BANK,
    name: '애큐온저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_ACUON,
    fucCode: FUC_CODE.SB_ACUON
  },
  SB_HB: {
    type: CorpType.SAVING_BANK,
    name: '㈜HB저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_HB,
    fucCode: FUC_CODE.SB_HB
  },
  SB_OSB: {
    type: CorpType.SAVING_BANK,
    name: 'OSB저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_OSB,
    fucCode: FUC_CODE.SB_OSB
  },
  SB_YEKARAM: {
    type: CorpType.SAVING_BANK,
    name: '예가람저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_YEKARAM,
    fucCode: FUC_CODE.SB_YEKARAM
  },
  SB_HANA: {
    type: CorpType.SAVING_BANK,
    name: '하나저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_HANA,
    fucCode: FUC_CODE.SB_HANA
  },
  SB_SBI: {
    type: CorpType.SAVING_BANK,
    name: 'SBI저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SBI,
    fucCode: FUC_CODE.SB_SBI
  },
  SB_SBI2: {
    type: CorpType.SAVING_BANK,
    name: 'SBI저축',
    myDataOrgCode: null,
    fucCode: FUC_CODE.SB_SBI2
  },
  SB_DB: {
    type: CorpType.SAVING_BANK,
    name: '디비저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DB,
    fucCode: FUC_CODE.SB_DB
  },
  SB_SKY: {
    type: CorpType.SAVING_BANK,
    name: '스카이저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SKY,
    fucCode: FUC_CODE.SB_SKY
  },
  SB_PYUNGTAEK: {
    type: CorpType.SAVING_BANK,
    name: '평택저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_PYUNGTAEK,
    fucCode: FUC_CODE.SB_PYUNGTAEK
  },
  SB_MK: {
    type: CorpType.SAVING_BANK,
    name: '민국저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_MK,
    fucCode: FUC_CODE.SB_MK
  },
  SB_CHOEUN: {
    type: CorpType.SAVING_BANK,
    name: '조은저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_CHOEUN,
    fucCode: FUC_CODE.SB_CHOEUN
  },
  SB_YOONGCHANG: {
    type: CorpType.SAVING_BANK,
    name: '융창저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_YOONGCHANG,
    fucCode: FUC_CODE.SB_YOONGCHANG
  },
  SB_NAMYANG: {
    type: CorpType.SAVING_BANK,
    name: '남양저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_NAMYANG,
    fucCode: FUC_CODE.SB_NAMYANG
  },
  SB_INSUNG: {
    type: CorpType.SAVING_BANK,
    name: '인성저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_INSUNG,
    fucCode: FUC_CODE.SB_INSUNG
  },
  SB_MOA: {
    type: CorpType.SAVING_BANK,
    name: '모아저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_MOA,
    fucCode: FUC_CODE.SB_MOA
  },
  SB_INCHEON: {
    type: CorpType.SAVING_BANK,
    name: '인천저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_INCHEON,
    fucCode: FUC_CODE.SB_INCHEON
  },
  SB_HANWHA: {
    type: CorpType.SAVING_BANK,
    name: '한화저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_HANWHA,
    fucCode: FUC_CODE.SB_HANWHA
  },
  SB_YOUNGJIN: {
    type: CorpType.SAVING_BANK,
    name: '영진저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_YOUNGJIN,
    fucCode: FUC_CODE.SB_YOUNGJIN
  },
  SB_JT: {
    type: CorpType.SAVING_BANK,
    name: 'JT저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_JT,
    fucCode: FUC_CODE.SB_JT
  },
  SB_ANGUK: {
    type: CorpType.SAVING_BANK,
    name: '안국저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_ANGUK,
    fucCode: FUC_CODE.SB_ANGUK
  },
  SB_SSIN: {
    type: CorpType.SAVING_BANK,
    name: '상상인저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SSIN,
    fucCode: FUC_CODE.SB_SSIN
  },
  SB_SERAM: {
    type: CorpType.SAVING_BANK,
    name: '세람저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SERAM,
    fucCode: FUC_CODE.SB_SERAM
  },
  SB_SAMJUNG: {
    type: CorpType.SAVING_BANK,
    name: '삼정저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_SAMJUNG,
    fucCode: FUC_CODE.SB_SAMJUNG
  },
  SB_BOORIM: {
    type: CorpType.SAVING_BANK,
    name: '부림저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_BOORIM,
    fucCode: FUC_CODE.SB_BOORIM
  },
  IS_SAMSUNGFIRE: {
    type: CorpType.INSURANCE,
    name: '삼성화재',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_SAMSUNGFIRE,
    fucCode: FUC_CODE.IS_SAMSUNGFIRE
  },
  IS_HI: {
    type: CorpType.INSURANCE,
    name: '현대해상',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_HI,
    fucCode: FUC_CODE.IS_HI
  },
  IS_DBFIRE: {
    type: CorpType.INSURANCE,
    name: 'DB손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_DBFIRE,
    fucCode: FUC_CODE.IS_DBFIRE
  },
  IS_KBFIRE: {
    type: CorpType.INSURANCE,
    name: 'KB손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_KBFIRE,
    fucCode: FUC_CODE.IS_KBFIRE
  },
  IS_MERITZFIRE: {
    type: CorpType.INSURANCE,
    name: '메리츠화재',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_MERITZFIRE,
    fucCode: FUC_CODE.IS_MERITZFIRE
  },
  IS_AXA: {
    type: CorpType.INSURANCE,
    name: 'AXA손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_AXA,
    fucCode: FUC_CODE.IS_AXA
  },
  IS_HANWHAFIRE: {
    type: CorpType.INSURANCE,
    name: '한화손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_HANWHAFIRE,
    fucCode: FUC_CODE.IS_HANWHAFIRE
  },
  IS_NHFIRE: {
    type: CorpType.INSURANCE,
    name: 'NH농협손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_NHFIRE,
    fucCode: FUC_CODE.IS_NHFIRE
  },
  IS_HANAFIRE: {
    type: CorpType.INSURANCE,
    name: '하나손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_HANAFIRE,
    fucCode: FUC_CODE.IS_HANAFIRE
  },
  IS_LOTTE: {
    type: CorpType.INSURANCE,
    name: '롯데손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_LOTTE,
    fucCode: FUC_CODE.IS_LOTTE
  },
  IS_AIGFIRE: {
    type: CorpType.INSURANCE,
    name: 'AIG손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_AIGFIRE,
    fucCode: FUC_CODE.IS_AIGFIRE
  },
  IS_HEUNGKUKFIRE: {
    type: CorpType.INSURANCE,
    name: '흥국화재',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_HEUNGKUKFIRE,
    fucCode: FUC_CODE.IS_HEUNGKUKFIRE
  },
  IS_CARROT: {
    type: CorpType.INSURANCE,
    name: '캐롯손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_CARROT,
    fucCode: FUC_CODE.IS_CARROT
  },
  IS_MG: {
    type: CorpType.INSURANCE,
    name: 'MG손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_MG,
    fucCode: FUC_CODE.IS_MG
  },
  IS_BNPFIRE: {
    type: CorpType.INSURANCE,
    name: 'BNP파리바손해',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_BNPFIRE,
    fucCode: FUC_CODE.IS_BNPFIRE
  },
  IS_LINAFIRE: {
    type: CorpType.INSURANCE,
    name: '라이나손해보험',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_LINAFIRE,
    fucCode: FUC_CODE.IS_LINAFIRE
  },
  IS_SAMSUNGLIFE: {
    type: CorpType.INSURANCE,
    name: '삼성생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_SAMSUNGLIFE,
    fucCode: FUC_CODE.IS_SAMSUNGLIFE
  },
  IS_HANWHALIFE: {
    type: CorpType.INSURANCE,
    name: '한화생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_HANWHALIFE,
    fucCode: FUC_CODE.IS_HANWHALIFE
  },
  IS_KYOBOLIFE: {
    type: CorpType.INSURANCE,
    name: '교보생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_KYOBOLIFE,
    fucCode: FUC_CODE.IS_KYOBOLIFE
  },
  IS_SHINHAN: {
    type: CorpType.INSURANCE,
    name: '신한라이프',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_SHINHAN,
    fucCode: FUC_CODE.IS_SHINHAN
  },
  IS_LINALIFE: {
    type: CorpType.INSURANCE,
    name: '라이나생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_LINALIFE,
    fucCode: FUC_CODE.IS_LINALIFE
  },
  IS_NHLIFE: {
    type: CorpType.INSURANCE,
    name: 'NH농협생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_NHLIFE,
    fucCode: FUC_CODE.IS_NHLIFE
  },
  IS_DONGYANG: {
    type: CorpType.INSURANCE,
    name: '동양생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_DONGYANG,
    fucCode: FUC_CODE.IS_DONGYANG
  },
  IS_AIGLIFE: {
    type: CorpType.INSURANCE,
    name: 'AIA생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_AIGLIFE,
    fucCode: FUC_CODE.IS_AIGLIFE
  },
  IS_MIRAE: {
    type: CorpType.INSURANCE,
    name: '미래에셋생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_MIRAE,
    fucCode: FUC_CODE.IS_MIRAE
  },
  IS_HEUNGKUKLIFE: {
    type: CorpType.INSURANCE,
    name: '흥국생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_HEUNGKUKLIFE,
    fucCode: FUC_CODE.IS_HEUNGKUKLIFE
  },
  IS_FUBON: {
    type: CorpType.INSURANCE,
    name: '푸본현대생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_FUBON,
    fucCode: FUC_CODE.IS_FUBON
  },
  IS_ABL: {
    type: CorpType.INSURANCE,
    name: 'ABL생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_ABL,
    fucCode: FUC_CODE.IS_ABL
  },
  IS_KDB: {
    type: CorpType.INSURANCE,
    name: 'KDB생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_KDB,
    fucCode: FUC_CODE.IS_KDB
  },
  IS_DGB: {
    type: CorpType.INSURANCE,
    name: 'iMT라이프생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_DGB,
    fucCode: FUC_CODE.IS_DGB
  },
  IS_MET: {
    type: CorpType.INSURANCE,
    name: '메트라이프생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_MET,
    fucCode: FUC_CODE.IS_MET
  },
  IS_DBLIFE: {
    type: CorpType.INSURANCE,
    name: 'DB생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_DBLIFE,
    fucCode: FUC_CODE.IS_DBLIFE
  },
  IS_KB_PRUDENTIAL: {
    type: CorpType.INSURANCE,
    name: 'KB라이프생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_KB_PRUDENTIAL,
    fucCode: FUC_CODE.IS_KB_PRUDENTIAL
  },
  IS_HANALIFE: {
    type: CorpType.INSURANCE,
    name: '하나생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_HANALIFE,
    fucCode: FUC_CODE.IS_HANALIFE
  },
  IS_CHUBBLIFE: {
    type: CorpType.INSURANCE,
    name: '처브라이프생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_CHUBBLIFE,
    fucCode: FUC_CODE.IS_CHUBBLIFE
  },
  IS_LIFEPLANET: {
    type: CorpType.INSURANCE,
    name: '교보라이프플래닛',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_LIFEPLANET,
    fucCode: FUC_CODE.IS_LIFEPLANET
  },
  IS_BNPLIFE: {
    type: CorpType.INSURANCE,
    name: 'BNP파리바생명',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_BNPLIFE,
    fucCode: FUC_CODE.IS_BNPLIFE
  },
  IS_SGIC: {
    type: CorpType.INSURANCE,
    name: '서울보증보험',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_SGIC,
    fucCode: FUC_CODE.IS_SGIC
  },
  IS_KOREAPOST: {
    type: CorpType.INSURANCE,
    name: '우체국',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_KOREAPOST,
    fucCode: FUC_CODE.IS_KOREAPOST
  },
  IS_IBKI: {
    type: CorpType.INSURANCE,
    name: 'IBK연금',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_IBKI,
    fucCode: FUC_CODE.IS_IBKI
  },
  IS_KAKAO_PAY_FIRE: {
    type: CorpType.INSURANCE,
    name: '카카오페이손해보험',
    myDataOrgCode: MY_DATA_ORG_CODE.IS_KAKAO_PAY_FIRE,
    fucCode: null
  },
  CAPITAL_KB_CARD: {
    type: CorpType.CAPITAL,
    name: 'KB국민카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_KB_CARD,
    fucCode: null
  },
  CAPITAL_WOORI_CARD: {
    type: CorpType.CAPITAL,
    name: '우리카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_WOORI_CARD,
    fucCode: null
  },
  CAPITAL_OK: {
    type: CorpType.CAPITAL,
    name: 'OK캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_OK,
    fucCode: FUC_CODE.CAPITAL_OK
  },
  CAPITAL_RCI: {
    type: CorpType.CAPITAL,
    name: 'RCI파이낸셜',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_RCI,
    fucCode: null
  },
  CAPITAL_MOORIM: {
    type: CorpType.CAPITAL,
    name: '무림캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_MOORIM,
    fucCode: null
  },
  CAPITAL_VOLKSWAGEN: {
    type: CorpType.CAPITAL,
    name: '폭스바겐파이낸셜',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_VOLKSWAGEN,
    fucCode: null
  },
  CAPITAL_HANA_CARD: {
    type: CorpType.CAPITAL,
    name: '하나카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_HANA_CARD,
    fucCode: null
  },
  CAPITAL_M: {
    type: CorpType.CAPITAL,
    name: 'M캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_M,
    fucCode: null
  },
  CAPITAL_MERITZ: {
    type: CorpType.CAPITAL,
    name: '메리츠캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_MERITZ,
    fucCode: null
  },
  CAPITAL_KICF: {
    type: CorpType.CAPITAL,
    name: '한국투자캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_KICF,
    fucCode: FUC_CODE.CAPITAL_KICF
  },
  CAPITAL_PORSCHE: {
    type: CorpType.CAPITAL,
    name: '포르쉐파이낸셜',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_PORSCHE,
    fucCode: null
  },
  CAPITAL_HYUNDAI: {
    type: CorpType.CAPITAL,
    name: '현대캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_HYUNDAI,
    fucCode: FUC_CODE.CAPITAL_HYUNDAI
  },
  CAPITAL_LOTTE_CARD: {
    type: CorpType.CAPITAL,
    name: '롯데카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_LOTTE_CARD,
    fucCode: null
  },
  CAPITAL_ORIX: {
    type: CorpType.CAPITAL,
    name: '오릭스캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_ORIX,
    fucCode: null
  },
  CAPITAL_KB: {
    type: CorpType.CAPITAL,
    name: 'KB캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_KB,
    fucCode: FUC_CODE.CAPITAL_KB
  },
  CAPITAL_CNH: {
    type: CorpType.CAPITAL,
    name: '씨앤에이치캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_CNH,
    fucCode: null
  },
  CAPITAL_LOTTE_AUTOLEASE: {
    type: CorpType.CAPITAL,
    name: '롯데오토리스',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_LOTTE_AUTOLEASE,
    fucCode: null
  },
  CAPITAL_VOLVO: {
    type: CorpType.CAPITAL,
    name: '볼보파이낸셜',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_VOLVO,
    fucCode: null
  },
  CAPITAL_A: {
    type: CorpType.CAPITAL,
    name: 'A캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_A,
    fucCode: null
  },
  CAPITAL_SAMSUNG_CARD: {
    type: CorpType.CAPITAL,
    name: '삼성카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_SAMSUNG_CARD,
    fucCode: null
  },
  CAPITAL_SHINHAN_CARD: {
    type: CorpType.CAPITAL,
    name: '신한카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_SHINHAN_CARD,
    fucCode: null
  },
  CAPITAL_KDBC: {
    type: CorpType.CAPITAL,
    name: 'KDB캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_KDBC,
    fucCode: null
  },
  CAPITAL_DB: {
    type: CorpType.CAPITAL,
    name: 'DB캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_DB,
    fucCode: null
  },
  CAPITAL_ECO: {
    type: CorpType.CAPITAL,
    name: '에코캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_ECO,
    fucCode: null
  },
  CAPITAL_BC_CARD: {
    type: CorpType.CAPITAL,
    name: '비씨카드',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_BC_CARD,
    fucCode: null
  },
  CAPITAL_ACUON: {
    type: CorpType.CAPITAL,
    name: '애큐온캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_ACUON,
    fucCode: FUC_CODE.CAPITAL_ACUON
  },
  CAPITAL_HB: {
    type: CorpType.CAPITAL,
    name: 'HB캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_HB,
    fucCode: null
  },
  CAPITAL_HANA: {
    type: CorpType.CAPITAL,
    name: '하나캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_HANA,
    fucCode: FUC_CODE.CAPITAL_HANA
  },
  CAPITAL_DGB: {
    type: CorpType.CAPITAL,
    name: 'iM캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_DGB,
    fucCode: FUC_CODE.CAPITAL_DGB
  },
  CAPITAL_DEUTSCH: {
    type: CorpType.CAPITAL,
    name: '도이치파이낸셜',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_DEUTSCH,
    fucCode: null
  },
  CAPITAL_HANKOOK: {
    type: CorpType.CAPITAL,
    name: '한국캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_HANKOOK,
    fucCode: FUC_CODE.CAPITAL_HANKOOK
  },
  CAPITAL_K_CAR: {
    type: CorpType.CAPITAL,
    name: '케이카캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_K_CAR,
    fucCode: null
  },
  CAPITAL_MASON: {
    type: CorpType.CAPITAL,
    name: '메이슨캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_MASON,
    fucCode: null
  },
  CAPITAL_MIRAE: {
    type: CorpType.CAPITAL,
    name: '미래에셋캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_MIRAE,
    fucCode: FUC_CODE.CAPITAL_MIRAE
  },
  CAPITAL_JB_WOORI: {
    type: CorpType.CAPITAL,
    name: 'JB우리캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_JB_WOORI,
    fucCode: FUC_CODE.CAPITAL_JB_WOORI
  },
  CAPITAL_SY: {
    type: CorpType.CAPITAL,
    name: 'SY오토캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_SY,
    fucCode: null
  },
  CAPITAL_BNK: {
    type: CorpType.CAPITAL,
    name: 'BNK캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_BNK,
    fucCode: FUC_CODE.CAPITAL_BNK
  },
  CAPITAL_KN: {
    type: CorpType.CAPITAL,
    name: '경남은행',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_KN,
    fucCode: null
  },
  CAPITAL_KIWWOOM: {
    type: CorpType.CAPITAL,
    name: '키움캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_KIWWOOM,
    fucCode: null
  },
  CAPITAL_WELCOME: {
    type: CorpType.CAPITAL,
    name: '웰컴캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_WELCOME,
    fucCode: FUC_CODE.CAPITAL_WELCOME
  },
  CAPITAL_BMW: {
    type: CorpType.CAPITAL,
    name: 'BMW파이낸셜',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_BMW,
    fucCode: null
  },
  CAPITAL_IBK: {
    type: CorpType.CAPITAL,
    name: 'IBK캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_IBK,
    fucCode: null
  },
  CAPITAL_WOORIF: {
    type: CorpType.CAPITAL,
    name: '우리금융캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_WOORIF,
    fucCode: FUC_CODE.CAPITAL_WOORIF
  },
  CAPITAL_HYUNDAI_COMMERCIAL: {
    type: CorpType.CAPITAL,
    name: '현대커머셜',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_HYUNDAI_COMMERCIAL,
    fucCode: null
  },
  CAPITAL_NH: {
    type: CorpType.CAPITAL,
    name: 'NH농협캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_NH,
    fucCode: FUC_CODE.CAPITAL_NH
  },
  CAPITAL_MERCEDES_BENZ: {
    type: CorpType.CAPITAL,
    name: '벤츠파이낸셜',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_MERCEDES_BENZ,
    fucCode: null
  },
  CAPITAL_TOYOTA: {
    type: CorpType.CAPITAL,
    name: '토요타파이낸셜',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_TOYOTA,
    fucCode: null
  },
  CAPITAL_LOTTE: {
    type: CorpType.CAPITAL,
    name: '롯데캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_LOTTE,
    fucCode: FUC_CODE.CAPITAL_LOTTE
  },
  CAPITAL_SHINHAN: {
    type: CorpType.CAPITAL,
    name: '신한캐피탈',
    myDataOrgCode: MY_DATA_ORG_CODE.CAPITAL_SHINHAN,
    fucCode: null
  },
  CAPITAL_8PERCENT: {
    type: CorpType.CAPITAL,
    name: '에잇퍼센트',
    myDataOrgCode: null,
    fucCode: FUC_CODE.CAPITAL_8PERCENT
  },
  CAPITAL_HONESTFUND: {
    type: CorpType.CAPITAL,
    name: '어니스트펀드',
    myDataOrgCode: null,
    fucCode: FUC_CODE.CAPITAL_HONESTFUND
  },
  TEL_SKT: {
    type: CorpType.TELECOM,
    name: 'SKT',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_SKT,
    fucCode: null
  },
  TEL_KT: {
    type: CorpType.TELECOM,
    name: 'KT',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_KT,
    fucCode: null
  },
  TEL_LGU: {
    type: CorpType.TELECOM,
    name: 'LG유플러스',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_LGU,
    fucCode: null
  },
  TEL_SKB: {
    type: CorpType.TELECOM,
    name: 'SK브로드밴드',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_SKB,
    fucCode: null
  },
  TEL_HELLOVISION: {
    type: CorpType.TELECOM,
    name: 'LG헬로비전',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_HELLOVISION,
    fucCode: null
  },
  TEL_SKYLIFE: {
    type: CorpType.TELECOM,
    name: 'KT스카이라이프',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_SKYLIFE,
    fucCode: null
  },
  TEL_DLIVE: {
    type: CorpType.TELECOM,
    name: '딜라이브',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_DLIVE,
    fucCode: null
  },
  TEL_CMB: {
    type: CorpType.TELECOM,
    name: 'CMB',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_CMB,
    fucCode: null
  },
  TEL_KTM: {
    type: CorpType.TELECOM,
    name: '케이티엠모바일',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_KTM,
    fucCode: null
  },
  TEL_HCN: {
    type: CorpType.TELECOM,
    name: '현대HCN',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_HCN,
    fucCode: null
  },
  TEL_U: {
    type: CorpType.TELECOM,
    name: 'U+알뜰모바일',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_U,
    fucCode: null
  },
  TEL_SK7: {
    type: CorpType.TELECOM,
    name: 'SK텔링크',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_SK7,
    fucCode: null
  },
  TEL_LIIVM: {
    type: CorpType.TELECOM,
    name: '리브모바일',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_LIIVM,
    fucCode: null
  },
  TEL_TOSS: {
    type: CorpType.TELECOM,
    name: '토스모바일',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_TOSS,
    fucCode: null
  },
  TEL_FINDIRECT: {
    type: CorpType.TELECOM,
    name: '핀다이렉트',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_FINDIRECT,
    fucCode: null
  },
  TEL_S1: {
    type: CorpType.TELECOM,
    name: '에스원',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_S1,
    fucCode: null
  },
  TEL_A: {
    type: CorpType.TELECOM,
    name: '에이모바일',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_A,
    fucCode: null
  },
  TEL_KCT: {
    type: CorpType.TELECOM,
    name: '티플러스',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_KCT,
    fucCode: null
  },
  TEL_SEJONG: {
    type: CorpType.TELECOM,
    name: '세종텔레콤',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_SEJONG,
    fucCode: null
  },
  TEL_FREET: {
    type: CorpType.TELECOM,
    name: '프리텔레콤',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_FREET,
    fucCode: null
  },
  TEL_JCN: {
    type: CorpType.TELECOM,
    name: 'JCN울산중앙방송',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_JCN,
    fucCode: null
  },
  TEL_KONAI: {
    type: CorpType.TELECOM,
    name: '코나아이',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_KONAI,
    fucCode: null
  },
  TEL_MOBING: {
    type: CorpType.TELECOM,
    name: '모빙',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_MOBING,
    fucCode: null
  },
  TEL_EYES: {
    type: CorpType.TELECOM,
    name: '아이즈모바일',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_EYES,
    fucCode: null
  },
  TEL_NIB: {
    type: CorpType.TELECOM,
    name: '남인천방송',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_NIB,
    fucCode: null
  },
  TEL_INSCOBEE: {
    type: CorpType.TELECOM,
    name: '인스코비',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_INSCOBEE,
    fucCode: null
  },
  TEL_ACN: {
    type: CorpType.TELECOM,
    name: 'ACN코리아',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_ACN,
    fucCode: null
  },
  TEL_EG: {
    type: CorpType.TELECOM,
    name: '이지모바일',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_EG,
    fucCode: null
  },
  TEL_KPMO: {
    type: CorpType.TELECOM,
    name: '한국피엠오',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_KPMO,
    fucCode: null
  },
  TEL_YLLAND: {
    type: CorpType.TELECOM,
    name: '와이엘랜드',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_YLLAND,
    fucCode: null
  },
  TEL_COINSHOT: {
    type: CorpType.TELECOM,
    name: '코인샷',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_COINSHOT,
    fucCode: null
  },
  TEL_WINNERSTEL: {
    type: CorpType.TELECOM,
    name: '위너스텔',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_WINNERSTEL,
    fucCode: null
  },
  TEL_ONKUKMIN: {
    type: CorpType.TELECOM,
    name: '온국민폰',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_ONKUKMIN,
    fucCode: null
  },
  TEL_SMARTEL: {
    type: CorpType.TELECOM,
    name: '스마텔',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_SMARTEL,
    fucCode: null
  },
  TEL_EYAGI: {
    type: CorpType.TELECOM,
    name: '이야기모바일',
    myDataOrgCode: MY_DATA_ORG_CODE.TEL_EYAGI,
    fucCode: null
  },
  BK_EXIM: {
    type: CorpType.BANK,
    name: '한국수출입은행',
    myDataOrgCode: null,
    fucCode: FUC_CODE.BK_EXIM
  },
  BK_HSBC: {
    type: CorpType.BANK,
    name: 'HSBC',
    myDataOrgCode: null,
    fucCode: FUC_CODE.BK_HSBC
  },
  BK_NFCF: {
    type: CorpType.BANK,
    name: '산림조합중앙회',
    myDataOrgCode: MY_DATA_ORG_CODE.BK_NFCF,
    fucCode: FUC_CODE.BK_NFCF
  },
  SB_DAOL: {
    type: CorpType.SAVING_BANK,
    name: '다올저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_DAOL,
    fucCode: FUC_CODE.SB_DAOL
  },
  SB_LENDIT: {
    type: CorpType.SAVING_BANK,
    name: '렌딧',
    myDataOrgCode: null,
    fucCode: FUC_CODE.SB_LENDIT
  },
  SB_KOREAINVEST: {
    type: CorpType.SAVING_BANK,
    name: '한국투자저축',
    myDataOrgCode: MY_DATA_ORG_CODE.SB_KOREAINVEST,
    fucCode: FUC_CODE.SB_KOREAINVEST
  },
  CAPITAL_PEOPLE_FUND: {
    type: CorpType.CAPITAL,
    name: '피플펀드',
    myDataOrgCode: null,
    fucCode: FUC_CODE.CAPITAL_PEOPLE_FUND
  },
  IS_THEK: {
    type: CorpType.INSURANCE,
    name: 'THE-K교직원공제회',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IS_THEK
  },
  IV_SSIN: {
    type: CorpType.INVEST,
    name: '상상인증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_SSIN,
    fucCode: FUC_CODE.IV_SSIN
  },
  IV_HANYANG: {
    type: CorpType.INVEST,
    name: '한양증권',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IV_HANYANG
  },
  IV_LEADING: {
    type: CorpType.INVEST,
    name: '리딩투자증권',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IV_LEADING
  },
  IV_BNK: {
    type: CorpType.INVEST,
    name: 'BNK증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_BNK,
    fucCode: FUC_CODE.IV_BNK
  },
  IV_BOOKOOK: {
    type: CorpType.INVEST,
    name: '부국증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_BOOKOOK,
    fucCode: FUC_CODE.IV_BOOKOOK
  },
  IV_CAPE: {
    type: CorpType.INVEST,
    name: '케이프투자증권',
    myDataOrgCode: MY_DATA_ORG_CODE.IV_CAPE,
    fucCode: FUC_CODE.IV_CAPE
  },
  IV_DS: {
    type: CorpType.INVEST,
    name: 'DS투자증권',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IV_DS
  },
  IV_KR: {
    type: CorpType.INVEST,
    name: 'KR투자증권',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IV_KR
  },
  IV_MACQUARIE: {
    type: CorpType.INVEST,
    name: '맥쿼리증권',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IV_MACQUARIE
  },
  IV_YUHWA: {
    type: CorpType.INVEST,
    name: '유화증권',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IV_YUHWA
  },
  IV_KOREAASSET: {
    type: CorpType.INVEST,
    name: '코리아에셋투자증권',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IV_KOREAASSET
  },
  IV_HEUNGKUK: {
    type: CorpType.INVEST,
    name: '흥국증권',
    myDataOrgCode: null,
    fucCode: FUC_CODE.IV_HEUNGKUK
  },
  POINT_11STREET: {
    type: CorpType.POINT,
    name: '11번가',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_11STREET,
    fucCode: null
  },
  POINT_DGBUPAY: {
    type: CorpType.POINT,
    name: 'iM유페이',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_DGBUPAY,
    fucCode: null
  },
  POINT_KGMOBILLIANCE: {
    type: CorpType.POINT,
    name: 'KG모빌리언스',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_KGMOBILLIANCE,
    fucCode: null
  },
  POINT_OKINVESTMENTPARTNERS: {
    type: CorpType.POINT,
    name: 'OK인베스트먼트파트너스',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_OKINVESTMENTPARTNERS,
    fucCode: null
  },
  POINT_OKCASHBACK: {
    type: CorpType.POINT,
    name: 'ok캐시백',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_OKCASHBACK,
    fucCode: null
  },
  POINT_PAYCO: {
    type: CorpType.POINT,
    name: 'PAYCO',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_PAYCO,
    fucCode: null
  },
  POINT_SKCOMMUNICATIONS: {
    type: CorpType.POINT,
    name: 'SK커뮤니케이션즈',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_SKCOMMUNICATIONS,
    fucCode: null
  },
  POINT_SMHIPLUS: {
    type: CorpType.POINT,
    name: 'SM하이플러스',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_SMHIPLUS,
    fucCode: null
  },
  POINT_SSGPAY: {
    type: CorpType.POINT,
    name: 'SSG페이',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_SSGPAY,
    fucCode: null
  },
  POINT_GOLFZONE: {
    type: CorpType.POINT,
    name: '골프존',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_GOLFZONE,
    fucCode: null
  },
  POINT_GOOGLEPAYMENTKOREA: {
    type: CorpType.POINT,
    name: '구글페이먼트코리아',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_GOOGLEPAYMENTKOREA,
    fucCode: null
  },
  POINT_GLOBALMONEYEXPRESS: {
    type: CorpType.POINT,
    name: '글로벌머니익스프레스',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_GLOBALMONEYEXPRESS,
    fucCode: null
  },
  POINT_NAVERPAY: {
    type: CorpType.POINT,
    name: '네이버페이',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_NAVERPAY,
    fucCode: null
  },
  POINT_CARROTPAY: {
    type: CorpType.POINT,
    name: '당근페이',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_CARROTPAY,
    fucCode: null
  },
  POINT_DECNCOMASSETMANAGEMENT: {
    type: CorpType.POINT,
    name: '디셈버앤컴퍼니자산운용',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_DECNCOMASSETMANAGEMENT,
    fucCode: null
  },
  POINT_LOKAMOBILITY: {
    type: CorpType.POINT,
    name: '로카모빌리티',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_LOKAMOBILITY,
    fucCode: null
  },
  POINT_LOTTESHOPPING: {
    type: CorpType.POINT,
    name: '롯데쇼핑',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_LOTTESHOPPING,
    fucCode: null
  },
  POINT_MYBI: {
    type: CorpType.POINT,
    name: '마이비',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_MYBI,
    fucCode: null
  },
  POINT_BAEMIN: {
    type: CorpType.POINT,
    name: '배달의민족',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_BAEMIN,
    fucCode: null
  },
  POINT_BANKSALAD: {
    type: CorpType.POINT,
    name: '뱅크샐러드',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_BANKSALAD,
    fucCode: null
  },
  POINT_BUSANHANAROCARD: {
    type: CorpType.POINT,
    name: '부산하나로카드',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_BUSANHANAROCARD,
    fucCode: null
  },
  POINT_BLUEWALNUT: {
    type: CorpType.POINT,
    name: '블루월넛',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_BLUEWALNUT,
    fucCode: null
  },
  POINT_SETTLEBANK: {
    type: CorpType.POINT,
    name: '세틀뱅크주식회사',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_SETTLEBANK,
    fucCode: null
  },
  POINT_SMILEPAY: {
    type: CorpType.POINT,
    name: '스마일페이',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_SMILEPAY,
    fucCode: null
  },
  POINT_LPOINT: {
    type: CorpType.POINT,
    name: '엘포인트',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_LPOINT,
    fucCode: null
  },
  POINT_WELCOMEPAYMENTS: {
    type: CorpType.POINT,
    name: '웰컴페이먼츠',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_WELCOMEPAYMENTS,
    fucCode: null
  },
  POINT_WEMAKEPRICE: {
    type: CorpType.POINT,
    name: '위메프',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_WEMAKEPRICE,
    fucCode: null
  },
  POINT_INTERPARK: {
    type: CorpType.POINT,
    name: '인터파크',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_INTERPARK,
    fucCode: null
  },
  POINT_KAKAO: {
    type: CorpType.POINT,
    name: '카카오',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_KAKAO,
    fucCode: null
  },
  POINT_KAKAOBANK: {
    type: CorpType.POINT,
    name: '카카오뱅크',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_KAKAOBANK,
    fucCode: null
  },
  POINT_KAKAOPAY: {
    type: CorpType.POINT,
    name: '카카오페이',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_KAKAOPAY,
    fucCode: null
  },
  POINT_KONAI: {
    type: CorpType.POINT,
    name: '코나아이',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_KONAI,
    fucCode: null
  },
  POINT_COOCON: {
    type: CorpType.POINT,
    name: '쿠콘',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_COOCON,
    fucCode: null
  },
  POINT_COUPANGPAY: {
    type: CorpType.POINT,
    name: '쿠팡페이',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_COUPANGPAY,
    fucCode: null
  },
  POINT_TOSSPAYMENTS: {
    type: CorpType.POINT,
    name: '토스페이먼츠',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_TOSSPAYMENTS,
    fucCode: null
  },
  POINT_TOSSPOINTS: {
    type: CorpType.POINT,
    name: '토스',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_TOSSPOINTS,
    fucCode: null
  },
  POINT_TRAVELWALLET: {
    type: CorpType.POINT,
    name: '트래블월렛',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_TRAVELWALLET,
    fucCode: null
  },
  POINT_TMONEY: {
    type: CorpType.POINT,
    name: '티머니',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_TMONEY,
    fucCode: null
  },
  POINT_TIMON: {
    type: CorpType.POINT,
    name: '티몬',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_TIMON,
    fucCode: null
  },
  POINT_FINSHOT: {
    type: CorpType.POINT,
    name: '핀샷',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_FINSHOT,
    fucCode: null
  },
  POINT_FINNQ: {
    type: CorpType.POINT,
    name: '핀크',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_FINNQ,
    fucCode: null
  },
  POINT_HANAMONEY: {
    type: CorpType.POINT,
    name: '하나머니',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_HANAMONEY,
    fucCode: null
  },
  POINT_KOREAPREPAIDCARD: {
    type: CorpType.POINT,
    name: '한국선불카드',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_KOREAPREPAIDCARD,
    fucCode: null
  },
  POINT_HANPAYSYS: {
    type: CorpType.POINT,
    name: '한페이시스',
    myDataOrgCode: MY_DATA_ORG_CODE.POINT_HANPAYSYS,
    fucCode: null
  }
};
// nice에서 일부 카드사는 이름 구분을 안해서 같이 선택하도록 예외 처리
const 같이_선택되어야하는_기관_목록 = {
  케이뱅크: ['케이뱅크', '케이뱅크카드'],
  카카오뱅크: ['카카오뱅크', '카카오뱅크카드'],
  씨티은행: ['씨티은행', '씨티카드'],
  KDB산업은행: ['KDB산업은행', 'KDB산업카드'],
  새마을금고: ['새마을금고', '새마을금고카드'],
  우체국은행: ['우체국은행', '우체국카드'],
  신협: ['신협', '신협카드'],
  수협은행: ['수협은행', '수협카드'],
  부산은행: ['부산은행', '부산은행카드'],
  대구은행: ['iM뱅크', '대구은행카드'],
  iM뱅크: ['iM뱅크', '대구은행카드'],
  광주은행: ['광주은행', '광주은행카드'],
  경남은행: ['경남은행', '경남은행카드'],
  전북은행: ['전북은행', '전북은행카드'],
  제주은행: ['제주은행', '제주은행카드']
};

export { FINANCIAL_CODE_DICTIONARY, FINANCIAL_NAME_MAP, 같이_선택되어야하는_기관_목록 };
